module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (73).97566e61.jpg";